import React from 'react';
import Typography from '@mui/material/Typography';

const CustomSubheader = ({ value }) => {
    return (
        <Typography variant="h4" color="text.secondary" sx={{fontWeight: '600', fontSize: '1.75rem', lineHeight: 1.3, paddingTop: 0.5, margin: 'auto', marginBottom: '15px'}} gutterBottom>
            {value}
        </Typography>
    );
};

export default CustomSubheader;